module.exports = __webpack_public_path__ + "img/farzana-christopher-115.95228b55.jpg";